<template>
<div class="bethistory-section winloss-detail">
        <div class="container">
            <div class="header-page-title">
                <h3>{{ $t('profit-and-loss-details','Profit And Loss Details')}}</h3>
            </div>
            <div class="bets-form">
                <div class="account-statement-filter-date">
                    <div class="d-flex w-100">
                        <div class="filter-date-form me-1">
                            <input type="date" v-model="fromDate" name="" id=""  class="form-control"/>
                        </div>
                        <div class="filter-date-form">
                            <input type="date" class="form-control" v-model="toDate" name="" id=""/>
                        </div>
                    </div>
                    <button @click ="getProfitLossDetail()"  class="btn thm-btn">{{$t('search','Search')}}</button>
                </div>
                <div class="account-statement-tbl">
                    <div class="table-responsive">
                        <table class="table b-table table-striped table-bordered bg-light">
                            <thead class="table-dark">
                                <tr>
                                    <th v-if="profitLossItem?.sport_id">EVENT NAME</th>
                                    <th>Date</th>
                                    <th v-if="!profitLossItem?.sport_id">Description</th>
                                    <th>P & L</th>
                                    <th v-if="!profitLossItem?.sport_id">Balance</th>
                                    <th v-if="profitLossItem?.sport_id">SHOW BETS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in profitAndLossList" :key="index">
                                    <td v-if="profitLossItem?.sport_id"> {{ item.event_name }} </td>
                                    <td> {{ item.event_date ? item.event_date : item.date  }} </td>
                                    <td v-if="!profitLossItem?.sport_id"> {{ item.des }} </td>
                                    <td :class="item.pl > 0 ? 'text-success' : 'text-danger'"> {{ $helper.positive(item.pl) }} </td>
                                    <td v-if="!profitLossItem?.sport_id"> {{ item.balance || '-' }} </td>
                                    <td v-if="profitLossItem?.sport_id"><button @click="showMatchBets(item)" class="btn view-bets-modal">Show Bets</button></td> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <BetsWinModal  :matchDetailId="matchDetailId" :toDate="toDate" :fromDate="fromDate" v-if="matchDetailId" @close-click="matchDetailId = null"/>
</template>
<script>
import BetsWinModal from "../components/BetsWinModal.vue";
export default {
    name: 'WinLoss',
    components: { BetsWinModal },
    data() {
        return {
            profitLossItem: null,
            profitAndLossList: null,
            fromDate:this.$dateTime.getDateSaperatedByDays(2),
            toDate: this.$dateTime.getcurrentDate('YYYY-MM-DD',new Date()),
            matchDetailId: null
        }
    },
    mounted() {
        this.profitLossItem = this.$store.getters.profitLossItem;
        this.getProfitLossDetail();
    },
    methods: {
        getProfitLossDetail(){
            this.$store.dispatch('setGlobalLoader', true);
            let data = {
                "from": this.$dateTime.getcurrentDate('YYYY-MM-DD', this.fromDate),
                "to": this.$dateTime.getDateAddedByDays(1, this.toDate,'YYYY-MM-DD'),
                "type": this.profitLossItem.type,
                "sport_id": this.profitLossItem.sport_id
            };
            
            this.$apiCall('post', 'GET_PROFIT_LOSS_PL_DETAIL', data, 'user', {page : this.pageNo}).then(response => {
                this.$store.dispatch('setGlobalLoader', false);
                this.openBetsList = [];
                if (response?.data?.error) {
                 this.$errorToast(response?.data?.error);
                } else {
                    if(this.profitLossItem.sport_id) {
                        this.profitAndLossList = response?.data?.data;
                    } else {
                        this.profitAndLossList = response?.data?.data.data;
                    }
                }
            }).catch(error => {
                if (error) {
                    this.$errorToast(error?.data?.message);
                }
            });
        },
        showMatchBets(item) {
            this.matchDetailId = item.match_id; 
            this.$helper.openModal('#worliallModal')
        }
    }

}
</script>